import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useAuthenticatedContext } from '@/app/components/Provider';

export const GuestModeAction = ({
  route,
  onAccessAsGuest,
}: {
  route: string;
  onAccessAsGuest: () => void;
}) => {
  const t = useTranslations();
  const { redirectToLogin } = useAuthenticatedContext();

  return (
    <>
      <VpButton
        data-testid="guest-mode-access-action"
        data-cy="guest-mode-access-action"
        variant="secondary"
        onClick={onAccessAsGuest}
      >
        {t('GUEST_MODAL.GUEST_MODE_CTA_LABEL')}
      </VpButton>
      <VpButton
        data-testid="guest-mode-login-action"
        onClick={async () => await redirectToLogin(route)}
      >
        {t('GLOBAL.LOGIN_2')}
      </VpButton>
    </>
  );
};
